var map = {
	"./albergolosone.jpg": [
		174,
		0
	],
	"./alpina.jpg": [
		175,
		1
	],
	"./ameronswissmountain.jpg": [
		176,
		12
	],
	"./artdecomontana.jpg": [
		177,
		23
	],
	"./arthotel_riposo.jpg": [
		178,
		34
	],
	"./atlantis.jpg": [
		179,
		45
	],
	"./backstage-vernissage.jpg": [
		180,
		56
	],
	"./badrutt-s-palace.jpg": [
		181,
		60
	],
	"./baur-au-lac.jpg": [
		182,
		61
	],
	"./beatus.jpg": [
		183,
		62
	],
	"./beaurivage.jpg": [
		184,
		2
	],
	"./beaurivagepalace.jpg": [
		185,
		3
	],
	"./bodmi.jpg": [
		186,
		4
	],
	"./buergenstock.jpg": [
		187,
		5
	],
	"./castello_del_sole.jpg": [
		188,
		6
	],
	"./chedi.jpg": [
		189,
		7
	],
	"./chesa-randolina.jpg": [
		190,
		8
	],
	"./de_rougemont.jpg": [
		191,
		9
	],
	"./doldenhorn.jpg": [
		192,
		10
	],
	"./dolder-grand.jpg": [
		193,
		11
	],
	"./eden-roc.jpg": [
		194,
		13
	],
	"./ermitage.jpg": [
		195,
		14
	],
	"./fairmontlemontreux.jpg": [
		196,
		15
	],
	"./fourseasons.jpg": [
		197,
		16
	],
	"./fruttfamilylodge.jpg": [
		198,
		17
	],
	"./giardino.jpg": [
		199,
		18
	],
	"./ginabelle.jpg": [
		200,
		19
	],
	"./grandhotelquellenhof.jpg": [
		201,
		20
	],
	"./gstaad_palace.jpg": [
		202,
		21
	],
	"./hof_weissbad.jpg": [
		203,
		22
	],
	"./huus-gstaad.jpg": [
		204,
		24
	],
	"./kempinski.jpg": [
		205,
		25
	],
	"./kulm.jpg": [
		206,
		26
	],
	"./la-reserve-geneve.jpg": [
		207,
		27
	],
	"./le-grand-bellevue.jpg": [
		208,
		28
	],
	"./lenkerhof.jpg": [
		209,
		29
	],
	"./lestroisrois.jpg": [
		210,
		30
	],
	"./maerchenhotelbraunwald.jpg": [
		211,
		31
	],
	"./mandarinoriental.jpg": [
		212,
		32
	],
	"./mirador.jpg": [
		213,
		33
	],
	"./nira-alpina.jpg": [
		214,
		35
	],
	"./pirmin_zurbriggen.jpg": [
		215,
		36
	],
	"./placeholder.jpg": [
		216,
		37
	],
	"./priva.jpg": [
		217,
		38
	],
	"./radissonblue.jpg": [
		218,
		39
	],
	"./rockresort.jpg": [
		219,
		40
	],
	"./romantik-hotel-julen-zermatt.jpg": [
		220,
		41
	],
	"./saratzt.jpg": [
		221,
		42
	],
	"./schweizerhof.jpg": [
		222,
		43
	],
	"./schweizerhofbern.jpg": [
		223,
		44
	],
	"./spitzhorn.jpg": [
		224,
		46
	],
	"./sunstar-arosa.jpg": [
		225,
		47
	],
	"./suvretta-house.jpg": [
		226,
		48
	],
	"./swiss_holiday_park.jpg": [
		227,
		49
	],
	"./thehide.jpg": [
		228,
		50
	],
	"./tschuggen.jpg": [
		229,
		51
	],
	"./ultima-gstaad.jpg": [
		230,
		52
	],
	"./valbellainn.jpg": [
		231,
		53
	],
	"./valsana.jpg": [
		232,
		54
	],
	"./victoriajungfrau.jpg": [
		233,
		55
	],
	"./vitznauerhof.jpg": [
		234,
		57
	],
	"./wellnesshotelgolfpanorama.jpg": [
		235,
		58
	],
	"./widder.jpg": [
		236,
		59
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 72;
module.exports = webpackAsyncContext;